<template>
  <QueryFrame
    @handlePage='handlePage'
    @handlePageSize='handlePageSize'
    :count='count'
    :current="page"
  >
    <div slot="queryParams" class="form">
      <div class="queryContainer">
        <div class="queryItem" v-if="this.$store.state.user.roleType !== 2">
          <label >门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label >供应商:</label>
          <lk-select placeholder='请选择' class="item" v-model.trim='query.supplierStoreIdList' multiple :filterable="true">
            <lk-option v-for="item in supplierList" :key="item.supplierId" :value='item.supplierId'>{{item.supplierName}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label >商品:</label>
          <lk-input class="item" placeholder='请输入商品编码/通用名' clearable v-model.trim="query.goodsCode"></lk-input>
        </div>
        <div class="queryItem">
          <label >创建日期:</label>
          <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.creatTime"></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label >审批日期:</label>
          <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.approvalTime"></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label >审批状态:</label>
          <lk-select placeholder='请选择' class="item" v-model.trim='query.status'>
            <lk-option v-for="item in statusList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
        </div>
    </div>
    <div slot="table">
      <div style="margin-bottom: 12px;">
        <lk-button class="mr8" type='primary' v-if="handlePermission('receiveableLimitAdd')" @click="toLogIn">录入其他返利</lk-button>
        <DownloadButton  @on-click="download" v-if="handlePermission('receiveableLimitDownload')"></DownloadButton>
      </div>
      <lk-table border :columns='columns' :data='tableData'/>
    </div>
  </QueryFrame>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import queryMixins from '../../mixins/queryMixins'; 
import mapState from '../../mixins/mapState';
import utils from '../../libs/utils';
import finance from '../../services/finance';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'otherProfitLog',
  components: {
    QueryFrame,
    DownloadButton
  },
  mixins: [queryMixins, mapState],
  data() {
    return {
      count: 0,
      page: 1,
      query: {
        storeIdList: [],
        supplierStoreIdList: [],
        goodsCode: '',
        creatTime: [],
        approvalTime: [],
        status: '',
      },
      statusList: [
        {
          id: 0,
          name: '审批中'
        },
        {
          id: 1,
          name: '审批通过'
        },
        {
          id: 2,
          name: '审批拒绝'
        },
      ],
      supplierList: [],
      tableData: [],
      columns: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '单号', key: 'code', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '审批状态', key: 'statusName', minWidth: 116 },
        { title: '创建时间', key: 'creatTimeStr', minWidth: 116 },
        { title: '审批时间', key: 'passTimeStr', minWidth: 116 },
        { title: '供应商', key: 'supplierName', minWidth: 116 },
        { title: '商品', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '批次号', key: 'batchSeq', minWidth: 116 },
        { title: '单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '返利方式', key: 'rebateWay', minWidth: 116 },
        { title: '返利金额', key: 'rebateAmount', minWidth: 116 },
        { 
          title: '操作',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'otherProfitLogCheck', params: {id: params.row.id }})
                }
              }
            }, '查看')
          ])
        },
      ],
    }
  },
  methods: {
    clear() {
      this.query = {
        storeIdList: [],
        supplierStoreIdList: [],
        goodsCode: '',
        creatTime: [],
        approvalTime: [],
        status: '',
      }
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      this.formatParams(params);
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      finance.downloadProfitReturnList(params).then(res => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toLogIn() {
      this.$router.push({ name: 'otherProfitLogAdd' });
    },
    getSupplierList() {
      finance.getSuppliers().then(res => {
        if (res.data.status === 200) {
          this.supplierList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    formatParams(params) {
      if (params.creatTime && params.creatTime.length) {
        params.createBeginTime = params.creatTime[0];
        params.createEndTime = params.creatTime[1];
      }
      if (params.approvalTime && params.approvalTime.length) {
        params.workBeginTime = params.approvalTime[0];
        params.workEndTime = params.approvalTime[1];
      }
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.formatParams(this.params);
      finance.getProfitReturnList(this.params).then(res => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.list) {
            res.data.data.list.forEach(item => {
              item.creatTimeStr = utils.formatDateToSecond(item.createTime);
              item.passTimeStr = utils.formatDateToSecond(item.passTime);
            });
            this.tableData = res.data.data.list;
            this.count = res.data.data.count;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    this.handleSearch(true);
    this.getSupplierList();
  }
}
</script>
<style lang="less" scoped>

</style>